// extracted by mini-css-extract-plugin
module.exports = {"title":"noattempts-widget_title__w1l0s","btns":"noattempts-widget_btns__2eld5","emailInfo":"noattempts-widget_emailInfo__ZsBcf"};